enum SceneType {
    CRYPTO = 0,
    TEXT = 1,
    CLOCK = 2,
    WEATHER = 3,
    GIF = 4,
    TIMER = 5,
    POMODORO = 6,
    OFF = 7,
    SPOTIFY = 8,
    COUNTDOWN = 9,
    CANVAS = 10,
    STOCK = 11,
    TWITCH = 12,
};

export default SceneType;
